/*
 * COPYRIGHT:     Copyright © 2018 - 2020 Xplorie LLC
 * Warning:       This product is protected by United States and international copyright laws.
 *                Unauthorized use or duplication of this software, in whole or in part, is prohibited.
 */

import React, { useEffect, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'
import { DATA_STATE_RECIEVED } from 'helpers/actionHelpers'
import { SimpleTable } from 'components/Tables'
import { usePrevious } from 'hooks'
import { HEADER } from './types'
import { buildTableColumns } from './helpers'

export function UnitTasksListComponent(props) {
  const {
    dataState,
    itemsCount,
    itemsPerPage,
    pageNumber,
    data,
    onGetData,
    needUpdate,
    extendedOptions,
    authUser,
    TableComponent,
    listWatchers,
    getApi,
    ...rest
  } = props
  const listApi = useRef()
  const previousWatchers = usePrevious(listWatchers)

  const onGetListApi = useCallback(
    api => {
      listApi.current = api
      if (getApi) {
        getApi(api)
      }
    },
    [getApi]
  )

  useEffect(() => {
    if (
      previousWatchers &&
      previousWatchers.length === listWatchers.length &&
      previousWatchers.some(
        (watcherDataState, index) =>
          watcherDataState !== listWatchers[index] && listWatchers[index] === DATA_STATE_RECIEVED
      )
    ) {
      onGetData(listApi.current.getListParameters())
    }
  }, [listWatchers, onGetData, previousWatchers])

  return (
    <TableComponent
      {...rest}
      getApi={onGetListApi}
      dataState={dataState}
      columns={buildTableColumns(props)}
      onGetData={onGetData}
      pageNumber={pageNumber}
      itemsPerPage={itemsPerPage}
      itemsCount={itemsCount}
      tableHeader={HEADER}
      data={data}
      withBasicAuth={false}
    />
  )
}

UnitTasksListComponent.defaultProps = {
  extendedOptions: {},
  needUpdate: false,
  TableComponent: SimpleTable,
  pageNumber: 1,
  getApi: null
}

UnitTasksListComponent.propTypes = {
  dataState: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  itemsCount: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  listWatchers: PropTypes.array.isRequired,
  onGetData: PropTypes.func.isRequired,
  needUpdate: PropTypes.bool,
  extendedOptions: PropTypes.object,
  authUser: PropTypes.object.isRequired,
  TableComponent: PropTypes.func,
  pageNumber: PropTypes.number,
  getApi: PropTypes.func
}
